module.exports = __webpack_public_path__ + "img/tips15.78ea8090.png";